import { ProviderAuthenticationCommon } from '~/plugins/data-connector/authentication/common'

export const ProviderAyrshareCommon = {
  key: 'ayrshare',
  authentication: ProviderAuthenticationCommon.Form(),
}

export type ProviderAyrshareAccountType = any

export type ProviderAyrshareConnectionType = {
  index: string
  profileName: string
  profileKey: string
  refId: string
  platform: string
}
